"use strict";

exports.__esModule = true;
exports.SurfaceThumbnail = SurfaceThumbnail;
var _react = _interopRequireDefault(require("react"));
var _getNonWidgetProps = require("../../ConfigurableLayout/common/getNonWidgetProps");
var _excluded = ["x", "y", "backgroundColor", "width", "height", "children", "render"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Thumbnail for SurfaceWidget.
 */
function SurfaceThumbnail(_ref) {
  var _ref$x = _ref.x,
    x = _ref$x === void 0 ? 0 : _ref$x,
    _ref$y = _ref.y,
    y = _ref$y === void 0 ? 0 : _ref$y,
    backgroundColor = _ref.backgroundColor,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 64 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 64 : _ref$height,
    children = _ref.children,
    render = _ref.render,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  var body = children.length > 0 ? render(children) : /*#__PURE__*/_react["default"].createElement("svg", {
    x: 0,
    y: 0,
    width: width,
    height: height
  }, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("pattern", {
    id: "dotBackground",
    x: 0,
    y: 0,
    width: 128,
    height: 128,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "32",
    cy: "32",
    r: "10",
    fill: "rgba(0, 0, 0, 0.3)"
  }))), /*#__PURE__*/_react["default"].createElement("rect", {
    fill: backgroundColor || "white",
    width: width,
    height: height
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    fill: "url(#dotBackground)",
    width: width,
    height: height
  }));
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    x: x,
    y: y,
    width: width,
    height: height
  }, (0, _getNonWidgetProps.getNonWidgetProps)(extra)), body);
}